export default __webpack_public_path__ + "static/media/360.8aed8d9e.gif";